import {Modal} from "antd";
import React from "react";

export const NextStepModal = ({isOpenNextStepModal, setIsOpenNextStepModal, nextStepData}) => {
    return (
        <Modal
            visible={isOpenNextStepModal}
            onCancel={() => setIsOpenNextStepModal(false)}
            onOk={() => setIsOpenNextStepModal(false)}
            okText="Tamam"
            cancelText="Kapat"
        >
            <div style={{display: "flex", flexDirection: "column", gap: 10}}>
                <h3>Vigo Ödeme</h3>
                <div>
                    Ödeme Türü:{" "}
                    {nextStepData?.vigoPayment?.paymentType === "creditCard"
                        ? "Kredi Kartı"
                        : nextStepData?.vigoPayment?.paymentType === "cash"
                        ? "Nakit"
                        : nextStepData?.vigoPayment?.paymentType}
                </div>
                <div>
                    Ödeme Durumu:{" "}
                    {nextStepData?.vigoPayment?.status === "pending"
                        ? "Ödeme Bekleniyor"
                        : nextStepData?.vigoPayment?.status}
                </div>
            </div>
        </Modal>
    );
};
